import React from 'react'
import Breadcrumb from '../components/Breadcrumb'
import ServicesSidebar from '../components/ServicesSidebar'

function SeoService() {
  return (
   <>
   <Breadcrumb title={"SEO "} tag ="Search Engine Optimization"/>
    {/* <!--services details start--> */}
            <section className="service-details-section pt-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-8">
                            <div className="service-details-wrap">
                                <img src="assets1/img/seo.jpg" alt="services" className="img-fluid rounded"/>
                                <div className="services-detail-content mt-4">
                                    <h4>SEO (SEARCH ENGINE OPTIMIZATION)</h4>
                                    <p>SEO (Search Engine Optimization)is nothing but the process of getting traffic from free, organic, editorial or natural search results on search engines. All major players like Google, Bing and Yahoo have primary search results, where web pages and other content such as videos or local listings are shown and ranked based on what the search engine considers most relevant to users.</p>
                                    <p>Get Top Rankings for your desired key-phrases and start getting quality leads / inquiries and multiply your sales. Yes, our SEO packages are designed to match your budget's and more importantly match expectations of search engines. We have very thoughtfully designed our packages so that the over all Search Engine Optimization process looks natural and stays affordable. With Savit, you will not be outsourcing your SEO project but will be getting a Search Engine Optimization (SEO) partner to work with you and help you identify a right internet marketing plan.</p>
                                    <p>With our SEO services in India, you can be rest assured about the ethical practices that we deploy for your website and the results that we deliver. Have a look at some of our standard SEO plans, mostly they should fit your requirements, if No then we can surely offer you a customized SEO package.</p>

                                    <div className="row mt-5">
                                        <div className="col-md-6">
                                            <div className="img-wrap">
                                                <img src="assets1/img/seo1.jpg" alt="services" className="img-fluid"/>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <ul className="list-unstyled tech-feature-list">
                                                <li className="py-1 pb-3">SEARCH ENGINE OPTIMIZATION INCLUDES</li>
                                                <li className="py-1"><span className="ti-check-box mr-2 color-secondary"></span><strong>Local Search Marketing</strong></li>
                                                <li className="py-1"><span className="ti-check-box mr-2 color-secondary"></span><strong>Analytics & Reporting</strong></li>
                                                <li className="py-1"><span className="ti-check-box mr-2 color-secondary"></span><strong>Mobile Search</strong></li>
                                                <li className="py-1"><span className="ti-check-box mr-2 color-secondary"></span><strong>Keyword Analysis</strong></li>
                                                <li className="py-1"><span className="ti-check-box mr-2 color-secondary"></span><strong>Paid Search</strong></li>
                                                <li className="py-1"><span className="ti-check-box mr-2 color-secondary"></span><strong>Link Building</strong></li>
                                               
                                            </ul>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                       <ServicesSidebar />
                    </div>
                </div>
            </section>
            {/* <!--services details end--> */}

   </>
  )
}

export default SeoService
